import { useRef } from 'react';
import { Session } from '../../../helpers/types';
import { useMixpanelContext } from '../../../Providers/MixpanelContext';
import { useUserContext } from '../../../Providers/UserContext';
import hatImage from '../../../assets/image/hat-icon.png';

interface ClassCardHeaderProps {
  session: Session;
  joinSession: (sessionId: number) => void;
  lang: string;
}

function ClassCardHeader({ session, joinSession, lang }: ClassCardHeaderProps) {
  const clickCount = useRef(0);
  const { mixpanelTrackEvent } = useMixpanelContext();
  const { user } = useUserContext();

  function handleClickOnTutorTitle() {
    if (process.env.REACT_APP_CONTENT_ENV === 'prod') {
      if (user?.id) {
        if (user.id === '116045799' || user.id === '116046062') {
          const newValue = clickCount.current + 1;
          clickCount.current = newValue;
          if (clickCount.current === 5) {
            clickCount.current = 0;
            mixpanelTrackEvent('ForcePreSessionNavigate', {
              SessionId: session?.id,
              UserId: user?.id,
              companyId: user?.b2b.companyId,
              groupId: user?.b2b.groupId,
              groupName: user?.b2b.groupName,
              companyName: user?.b2b.companyName,
              userRoles: user?.roles,
            });
            joinSession(session.id);
          }
          setTimeout(() => {
            clickCount.current = 0;
          }, 5000);
        }
      }
    } else {
      const newValue = clickCount.current + 1;
      clickCount.current = newValue;
      if (clickCount.current === 5) {
        clickCount.current = 0;
        joinSession(session.id);
      }
      setTimeout(() => {
        clickCount.current = 0;
      }, 5000);
    }
  }
  return (
    <section className="class-card-header-container" dir={lang === 'ar' ? 'rtl' : 'ltr'}>
      <div className="card-main">
        <div className="card-header flex justify-start">
          <div onClick={() => handleClickOnTutorTitle()} aria-hidden>
            <div className="card-title">{session?.className}</div>
            <div className="card-subtitle font-bold flex">
              <div
                className="class-info-item class-size flex justify-start align-center"
                style={{ paddingInlineStart: '1px' }}
              >
                <img className="card-icon-img" src={hatImage} alt="hat-icon" />
                <div>
                  {session.tutor.firstName} {session.tutor.lastName}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ClassCardHeader;
